module.exports = __webpack_public_path__ + "resources/img/career-welfareImg1.014aa509.jpg";